<template>
  <div class="jp-container">
    <div class="jp-page-wrapper">
      <nuxt />
    </div>
  </div>
</template>
<script>
export default {
  components: {}
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/common.scss';

.jp-container {
  height: 100vh;
  width: 100%;
}

.jp-page-wrapper {
  width: 100%;
  height: 100%;
}
</style>
